// ** Icons Import
// ** Icons Import
import { Home, Grid } from 'react-feather'

export default [
  {
    id: 'dashboard',
    title: 'Dashboard',
    icon: <Grid  style={{width: '25px', height: '25px', marginRight: '10px'}} />,
    badge: 'light-warning',
    navLink: '/dashboard',
    permissions: ['admin', 'any', 'masteradmin', 'customer']
  }
]